<template>
  <layout>
    <div>
      <div class="login-form-container">
        <div class="login-form-inner">
          <div class="logo">
            <img src="assets/logo.png" alt="" />
          </div>
          <h1 style="margin-top: 60px; margin-bottom: 30px">
            Password Reset Link Sent Successfully
          </h1>
          <p>Please check your email inbox</p>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import layout from './Layout';

export default {
  metaInfo: { title: 'Password Reset Link Sent' },
  components: {
    layout,
  },
};
</script>
